import styled, { css } from "styled-components";

import { stylesGlobalDefault } from "../../global/globalStyle";

interface Props {
  active?: boolean;
  disableInteractions?: boolean; // Make it optional
}

type ContainerProps = {
  disableInteractions?: boolean; // Make it optional
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 28px;
  width: 100%;
  ${(props) =>
    props.disableInteractions == true &&
    css`
      cursor: not-allowed;
    `}
`;


export const Title = styled.label`
  color: ${stylesGlobalDefault.black};
  margin-left: 12px;
  font-weight: 400;
  font-size: 14px;
`;
